<template lang="pug">
SideOverlaySlot(
  :isOpen="isOpen",
  title="ADD NEW"
  @closeOverlay="closeOverlay"
)
  template(#contentTop)
    .form-group
      label(for="patient-navigation-name") Entry Name (Required)
      input#patient-navigation-name(type="text" v-model="name")
  template(#footer)
    .flex.flex--space-between
      BaseBtn.x-lg.red-outline(
        @click.prevent="closeOverlay"
      ) CANCEL
      BaseBtn.x-lg.green(
        type="button"
        @click="createPatientNavigationSettingEntry"
        :disabled="!name"
      ) CONTINUE
</template>

<script>
import { defineComponent } from "vue";
import SideOverlaySlot from "@/components/overlays/SideOverlaySlot.vue";
import { createPatientNavigationSetting } from "@/api/patientNavigationSettingsApi";
import { apiStatus, apiStatusComputedFactory } from "@/api";

const { IDLE, PENDING, SUCCESS, ERROR } = apiStatus;

export default defineComponent({
  components: { SideOverlaySlot },
  emits: ["closeAddPatientNavigationSettingOverlay"],
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      name: "",
      createPatientNavigationSettingStatus: IDLE,
    };
  },
  computed: {
    ...apiStatusComputedFactory(["createPatientNavigationSettingStatus"]),
  },
  methods: {
    closeOverlay() {
      this.name = "";
      this.$emit("closeAddPatientNavigationSettingOverlay");
    },
    async createPatientNavigationSettingEntry() {
      if (!this.name) return;
      this.createPatientNavigationSettingStatus = PENDING;
      try {
        await createPatientNavigationSetting({
          patientNavigationSetting: { name: this.name },
        });
        this.createPatientNavigationSettingStatus = SUCCESS;
        this.closeOverlay();
      } catch (error) {
        console.log(error);
        this.createPatientNavigationSettingStatus = ERROR;
      }
    },
  },
});
</script>

<style scoped lang="scss"></style>
